import { Icon, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface InvoiceBillingCardProps {
  companyName?: string;
  operatorName?: string;
  isDefault?: boolean;
}

export const InvoiceBillingCard = ({ companyName, operatorName, isDefault }: InvoiceBillingCardProps) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <Icon name="DocumentText" size={20} className="text-neutral-black" />
      <Typography variant="action" className="text-neutral-black">
        Invoicing
      </Typography>
    </div>
    <div
      className={clsx(
        "flex flex-col gap-3 rounded-lg border p-3.5 lg:flex-row lg:items-center",
        isDefault ? "border-vivid-purple bg-vivid-purple/5" : "border-neutral-mid-gray bg-neutral-surface-gray"
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-1 sm:flex-row sm:items-start sm:gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded border border-neutral-mid-gray bg-white">
          <Icon name="DocumentText" size={18} className="text-neutral-dark-gray" />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex items-center gap-1.5">
            <Typography variant="action" className="text-neutral-black">
              Company Invoicing
            </Typography>
            {isDefault && (
              <Typography variant="action" className="text-vivid-purple">
                (Default)
              </Typography>
            )}
          </div>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Trips are billed to your company account and settled by invoice. No card is charged at booking.
          </Typography>
          {companyName && (
            <Typography variant="small-regular" className="text-neutral-silver-gray">
              Billed to: {companyName}
            </Typography>
          )}
        </div>
      </div>
    </div>
    <Typography variant="small-regular" className="text-neutral-silver-gray">
      Invoicing is set up by your company. To change billing terms, contact {(operatorName || "your operator").replace(/\.+$/, "")}.
    </Typography>
  </div>
);
